export function normalizeCalculationResponse(data) {
  if (!data) return null;

  if (Array.isArray(data)) {
    return normalizeCalculationResponse(data[0]);
  }

  if (data.summary) {
    const lineItem = data.line_items?.[0] ?? {};
    const convenienceFee =
      Number(
        data.summary.total_platform_fee ?? data.summary.platform_fee ?? 0,
      ) || 0;

    return {
      subtotal: Number(
        data.summary.original_subtotal ?? data.summary.subtotal ?? 0,
      ),
      discount_amount: Number(data.summary.discount_amount ?? 0),
      total_after_tax: Number(data.summary.total_amount ?? 0),
      convenience_fee: convenienceFee > 0 ? convenienceFee : null,
      platform_fee_base: Number(data.summary.platform_fee ?? 0),
      platform_fee_tax_amount: Number(data.summary.platform_fee_tax_amount ?? 0),
      ticket_tax_details:
        Number(data.summary.ticket_tax_amount ?? 0) > 0
          ? data.ticket_tax_details
          : null,
      platform_fee_tax_details:
        convenienceFee > 0 ? data.platform_fee_tax_details : null,
      discount: lineItem.discount ?? null,
    };
  }

  if (
    data.total_amount != null ||
    data.original_subtotal != null ||
    data.subtotal != null
  ) {
    const lineItem = data.line_items?.[0] ?? {};
    const convenienceFee = Number(data.convenience_fee ?? 0) || 0;
    const taxAmount = Number(data.tax_amount ?? 0);

    return {
      subtotal: Number(data.original_subtotal ?? data.subtotal ?? 0),
      discount_amount: Number(data.discount_amount ?? 0),
      total_after_tax: Number(data.total_amount ?? 0),
      convenience_fee: convenienceFee > 0 ? convenienceFee : null,
      platform_fee_base: Number(data.platform_fee_base ?? 0),
      platform_fee_tax_amount: Number(data.platform_fee_tax_amount ?? 0),
      ticket_tax_details: taxAmount > 0 ? data.ticket_tax_details : null,
      platform_fee_tax_details:
        convenienceFee > 0 ? data.platform_fee_tax_details : null,
      discount: lineItem.discount ?? null,
    };
  }

  return {
    subtotal: Number(data.subtotal ?? 0),
    discount_amount: Number(data.discount_amount ?? 0),
    total_after_tax: Number(data.total_after_tax ?? data.total ?? 0),
    convenience_fee: data.total_after_platform_fee ?? null,
    platform_fee_base: Number(data.platform_fee ?? 0),
    platform_fee_tax_amount: 0,
    ticket_tax_details: data.ticket_tax_details ?? null,
    platform_fee_tax_details: data.platform_fee_tax_details ?? null,
    discount: data.discount ?? null,
  };
}
